import { QueryFunctionContext } from '@tanstack/react-query';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import {
  AUTOCOMPLETE_PAGE_SIZE,
  OptionsPage,
  OptionType,
  Page,
} from '../../common/queryClient';
import { ClassifierUrl } from './ClassifierUrl';
import { ClassifierOverviewDto } from '../types';
import { useInfiniteSearchQuery } from '../../common/queryClient/useInfiniteSearchQuery';
import { formatCodeName } from '../../common/utils';

export interface SearchClassifiersQueryParams {
  searchText: string;
  selectedClassifier?: string;
  page?: number;
  size?: number;
}

export const searchClassifiers = ({
  searchText,
  selectedClassifier,
  page,
  size,
}: SearchClassifiersQueryParams) =>
  apiClient
    .get<Page<ClassifierOverviewDto>>(
      expand(ClassifierUrl.CLASSIFIER, {
        search: searchText,
        selectedClassifier,
        page,
        size,
      })
    )
    .then((response) => response.data);

const createSearchClassifiers = async ({
  meta,
  pageParam,
}: QueryFunctionContext<any, number>): Promise<OptionsPage> => {
  const page = pageParam ?? 0;
  const result = await searchClassifiers({
    searchText: (meta?.searchText ?? '') as string,
    selectedClassifier: meta?.selectedClassifier as string | undefined,
    page,
    size: AUTOCOMPLETE_PAGE_SIZE,
  });

  const content: OptionType[] = result.content.map((item) => {
    return {
      value: item.code,
      label: formatCodeName(item),
    };
  });
  return {
    content,
    last: result.last,
    number: result.number,
  };
};

export function useInfiniteSearchClassifiersQuery(
  term: string,
  selectedClassifier?: string
) {
  return useInfiniteSearchQuery(
    ['search-classifiers-autocomplete'],
    createSearchClassifiers,
    term,
    { selectedClassifier }
  );
}
